import { render, staticRenderFns } from "./studentCard.vue?vue&type=template&id=315dd8e0&scoped=true&"
import script from "./studentCard.vue?vue&type=script&lang=js&"
export * from "./studentCard.vue?vue&type=script&lang=js&"
import style0 from "./studentCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./studentCard.vue?vue&type=style&index=1&id=315dd8e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315dd8e0",
  null
  
)

export default component.exports